"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _AspectRatio = _interopRequireDefault(require("./AspectRatio"));

var _Body = _interopRequireDefault(require("./Body"));

var _Caption = _interopRequireDefault(require("./Caption"));

var _CardHorizontal = require("./CardHorizontal");

var _CardNavigation = require("./CardNavigation");

var _Context = _interopRequireDefault(require("./Context"));

var _Description = _interopRequireDefault(require("./Description"));

var _Group = _interopRequireDefault(require("./Group"));

var _Row = _interopRequireDefault(require("./Row"));

var _excluded = ["active", "children", "className", "displayType", "selectable"],
    _excluded2 = ["children", "horizontal", "interactive"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayCard = function ClayCard(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      displayType = _ref.displayType,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var isCardType = {
    file: displayType === 'file',
    image: displayType === 'image',
    user: displayType === 'user'
  };
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      horizontal: false,
      interactive: false
    }
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, {
      active: active,
      card: !selectable,
      'file-card': isCardType.file,
      'form-check-card form-check form-check-top-left': selectable,
      'image-card': isCardType.image,
      'user-card': isCardType.user
    }, 'card-type-asset')
  }, otherProps), selectable ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, children) : children));
};

function ClayCardHybrid(_ref2) {
  var children = _ref2.children,
      horizontal = _ref2.horizontal,
      interactive = _ref2.interactive,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  var Container = interactive ? _CardNavigation.ClayCardNavigation : horizontal ? _CardHorizontal.ClayCardHorizontal : ClayCard;
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    horizontal: horizontal
  }, otherProps), children);
}

ClayCardHybrid.displayName = 'ClayCard';
ClayCardHybrid.AspectRatio = _AspectRatio.default;
ClayCardHybrid.Body = _Body.default;
ClayCardHybrid.Caption = _Caption.default;
ClayCardHybrid.Description = _Description.default;
ClayCardHybrid.Group = _Group.default;
ClayCardHybrid.Row = _Row.default;
var _default = ClayCardHybrid;
exports.default = _default;